import { render, staticRenderFns } from "./dialogEditContact.vue?vue&type=template&id=60b5aa10"
import script from "./dialogEditContact.vue?vue&type=script&lang=js"
export * from "./dialogEditContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports